/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logo-lg[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{position:relative;left:-48px}@media (max-width:767px){.logo-lg[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{position:static}}"];
export { styles as styles };
